import { render, staticRenderFns } from "./PSwitchableAccountList.vue?vue&type=template&id=8505fd78&scoped=true&"
import script from "./PSwitchableAccountList.vue?vue&type=script&lang=ts&"
export * from "./PSwitchableAccountList.vue?vue&type=script&lang=ts&"
import style0 from "./PSwitchableAccountList.vue?vue&type=style&index=0&id=8505fd78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8505fd78",
  null
  
)

export default component.exports